var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5H23M12.5 2V23M7.6 2H17.4C19.3602 2 20.3403 2 21.089 2.38148C21.7475 2.71703 22.283 3.25247 22.6185 3.91103C23 4.65972 23 5.63982 23 7.6V17.4C23 19.3602 23 20.3403 22.6185 21.089C22.283 21.7475 21.7475 22.283 21.089 22.6185C20.3403 23 19.3602 23 17.4 23H7.6C5.63982 23 4.65972 23 3.91103 22.6185C3.25247 22.283 2.71703 21.7475 2.38148 21.089C2 20.3403 2 19.3602 2 17.4V7.6C2 5.63982 2 4.65972 2.38148 3.91103C2.71703 3.25247 3.25247 2.71703 3.91103 2.38148C4.65972 2 5.63982 2 7.6 2Z",
    stroke: "#001253",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.0a885cbd2c0de9fe74b7293358f29b11.svg";
export { ForwardRef as ReactComponent };